import { render, staticRenderFns } from "./SessionBar.vue?vue&type=template&id=e8b22358"
import script from "./SessionBar.vue?vue&type=script&lang=js"
export * from "./SessionBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports